import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, ButtonBase, Container, Icon, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { goToControl, selectIncompleteControls, selectMissingFindings } from '../../redux/reducers/assessmentReducer';
import { selectTitle } from '../../redux/reducers/catalogsReducer';

const prefixes = {
  'ISO27001:2013': '',
  'ISO27002:2013': '',
  'ISO27001:2022': '',
  'ISO27002:2022': 'A.',
  'SOC2:2017': 'S.',
};

function ControlItem({ control, handleLink }) {
  const controlTitle = useSelector((state) => selectTitle(state, control.id));
  const prefix = prefixes[control.id.split(':').slice(0, 2).join(':')];
  return (
    <ButtonBase id={`go-to-${control.id}`} onClick={() => handleLink(control.id)} variant="controlLink">
      <Typography variant="controlList1">
        {`${prefix}${controlTitle}`}
      </Typography>
      <Icon>
        <ChevronRightIcon />
      </Icon>
    </ButtonBase>
  );
}

function UnfinishedControls() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const incompleteControls = useSelector(selectIncompleteControls);
  const missingFindings = useSelector(selectMissingFindings);
  const handleLink = (id) => {
    dispatch(goToControl(id));
  };
  return (
    <Container disableGutters sx={{ pt: 2 }}>
      <Typography variant="h6">{t('assessment.unfinishedControls.title')}</Typography>
      {incompleteControls.length === 0 && missingFindings.length === 0 ? (
        <Box sx={{ mt: 2 }}>
          <Typography id="all-controls-evaluated" >{t('assessment.unfinishedControls.allControlsEval')}</Typography>
        </Box>
      ) : (
        <Stack spacing={2}>
          {incompleteControls.length > 0 && (
            <Stack sx={{ pt: 2 }} spacing={2}>
              <Typography>{t('assessment.unfinishedControls.notDoneDescription')}</Typography>
              <Stack>
                {incompleteControls.map((control) => (
                  <ControlItem id={`go-to-${control.name}`} control={control} key={control.id} handleLink={handleLink} />
                ))}
              </Stack>
            </Stack>
          )}
          {missingFindings.length > 0 && (
            <Stack sx={{ pt: 2 }} spacing={2}>
              <Typography>{t('assessment.unfinishedControls.issuesFoundDescription')}</Typography>
              <Stack>
                {missingFindings.map((control) => (
                  <ControlItem id={`go-to-${control.name}`} control={control} key={control.id} handleLink={handleLink} />
                ))}
              </Stack>
            </Stack>
          )}
        </Stack>
      )}
    </Container>
  );
}

export default UnfinishedControls;
